var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('legend',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }